// src/config/axiosInstance.js
import axios from 'axios';
import { BASE_URL } from '../config'; 

// Creates a configured axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor to add the token to requests
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token'); // Obtain the token from local storage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; //Add token to headers
    }
    return config;
  },
  error => Promise.reject(error)
);

export default axiosInstance;
